module.exports = __webpack_public_path__ + "img/img2.a60e9568.png";